<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.inventories'), $t('action.check') + '：' + shopName]"
      ></breadcrumb>
      <div class="container">
        <el-form ref="formObjForm" :model="formObj" size="small">
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>{{ $t("text.baseInfo") }}</legend>
              <div
                v-for="(item, index) in formObj.items"
                :key="index"
                :class="
                  index == formObj.items.length - 1 ? '' : 'border-bottom mgb10'
                "
              >
                <el-row :gutter="10">
                  <el-col :span="5">
                    <el-form-item>
                      <el-autocomplete
                        size="small"
                        v-model.trim="item.productNo"
                        :fetch-suggestions="querySearchProductNo"
                        :data-index="index"
                        :trigger-on-focus="false"
                        style="width: 100%"
                        :placeholder="
                          $t('rules.mustFillSimple', [$t('product.productNo')])
                        "
                        @focus="getFoucs(index)"
                        @blur="checkExist(index)"
                        @select="handleSelectProductNo(index)"
                      >
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item>
                      <el-autocomplete
                        size="small"
                        v-model.trim="item.color"
                        :fetch-suggestions="querySearchColor"
                        :placeholder="$t('product.color')"
                        style="width: 100%"
                        @focus="getFoucs(index)"
                        @blur="checkExist(index)"
                        @select="handleSelectColor(index)"
                      ></el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item>
                      <el-autocomplete
                        size="small"
                        v-model.trim="item.size"
                        :fetch-suggestions="querySearchSize"
                        :placeholder="$t('product.size')"
                        style="width: 100%"
                        @focus="getFoucs(index)"
                        @blur="checkExist(index)"
                        @select="handleSelectSize(index)"
                      ></el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item>
                      <el-input
                        size="small"
                        v-model.trim="item.quantity"
                        :placeholder="
                          $t('rules.mustFillSimple', [$t('inventory.quantity')])
                        "
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item>
                      <el-input
                        size="small"
                        v-model.trim="item.warnQuantity"
                        :placeholder="$t('inventory.warnQuantity')"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col v-if="item._localRepeatFg" :span="3">
                    <el-form-item>
                      <small class="red">
                        {{ $t("prompt.hasBeenSelectProduct") }}
                      </small>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="index" :span="1">
                    <el-form-item>
                      <i class="el-icon-delete red" @click="remove(index)" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div class="center">
                <el-button
                  v-if="formObj.items.length < 10"
                  type="info"
                  @click="addMore"
                  plain
                  round
                  >{{ $t("action.addProduct") }}</el-button
                >
                <span v-else class="orange">
                  {{ $t("prompt.addMorePrompt") }}
                </span>
              </div>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import Size from "@/api/size.js";
import Color from "@/api/color.js";
import Product from "@/api/product.js";
import Inventory from "@/api/inventory.js";

function bulid() {
  return {
    inventoryId: null,
    shopId: null,
    productNo: null,
    size: null,
    color: null,
    quantity: null,
    warnQuantity: null,
    images: null,
    // customQuantity: null,
    // remark: null,
    // manualLockQuantity: null,
    // manualLockRemark: null,
    _productNoColors: [],
    _productNoSizes: [],
    _localRepeatFg: false,
  };
}
export default {
  mixins: [page],
  components: { BackButton },
  data() {
    return {
      Util: Util,
      shops: [],
      shopId: null,
      shopName: null,
      colors: [],
      sizes: [],
      formObj: {
        items: [bulid(), bulid(), bulid()],
      },
      products: [],
      currentShopShelfs: [],
      saveDoing: false,
      currentIndex: null,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.shopId = self.$route.params.shopId;
    self.shopName = self.$route.query.shopName;
    axios.all([Size.findByTenantId(), Color.findByTenantId()]).then(
      axios.spread(function (sizes, colors) {
        if (sizes.status === 200) {
          self.sizes = sizes.data;
        } else {
          self.sysError();
        }
        if (colors.status === 200) {
          self.colors = colors.data;
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    getFoucs(index) {
      const self = this;
      self.currentIndex = index;
    },
    querySearchProductNo(queryString, cb) {
      const self = this;
      self.formObj.items[self.currentIndex].size = null;
      self.formObj.items[self.currentIndex].color = null;
      self.formObj.items[self.currentIndex].warnQuantity = null;
      self.formObj.items[self.currentIndex].inventoryId = null;
      self.formObj.items[self.currentIndex].shopId = null;
      self.formObj.items[self.currentIndex]._productNoColors = [];
      self.formObj.items[self.currentIndex]._productNoSizes = [];
      self.formObj.items[self.currentIndex]._localRepeatFg = false;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({
        productNo: queryString,
        type: "product",
      }).then(function (res) {
        const ps = res.data;
        ps.forEach((p) => (p.value = p.productNo));
        self.products = ps;
        cb(self.products);
      });
    },
    handleSelectProductNo(index) {
      const item = this.products.find(
        (p) => p.productNo === this.formObj.items[index].productNo
      );
      this.formObj.items[index]._productNoColors = item.colors || [];
      this.formObj.items[index]._productNoSizes = item.sizes || [];
      this.formObj.items[index].size = null;
      this.formObj.items[index].color = null;
      this.checkExist(index);
    },
    checkExist(index) {
      const self = this;
      self.formObj.items[index].inventoryId = null;
      self.formObj.items[index]._localRepeatFg = false;
      const searchObj = {
        shopId: self.shopId,
        productNo: self.formObj.items[index].productNo,
        color: self.formObj.items[index].color,
        size: self.formObj.items[index].size,
      };
      Inventory.findByProductInfo(searchObj).then(function (res) {
        if (res.data.code === 200) {
          self.formObj.items[index].inventoryId = res.data.entity.id;
          self.formObj.items[index].quantity = res.data.entity.quantity;
          self.formObj.items[index].warnQuantity = res.data.entity.warnQuantity;
        } else {
          self.formObj.items[index].inventoryId = null;
          self.formObj.items[index].warnQuantity = null;
          self.formObj.items[index].quantity = null;
        }
      });
      // 前台本地过滤
      const iis = self.formObj.items.filter(function (ii) {
        return (
          ii.productNo === self.formObj.items[index].productNo &&
          ii.color === self.formObj.items[index].color &&
          ii.size === self.formObj.items[index].size
        );
      });
      if (iis.length > 1) {
        self.formObj.items[index]._localRepeatFg = true;
        return;
      }
    },

    // 颜色
    querySearchColor(queryString, cb) {
      const self = this;
      let colors = [];
      if (this.formObj.items[self.currentIndex]._productNoColors.length !== 0) {
        colors = this.formObj.items[self.currentIndex]._productNoColors.map(
          (pc) => {
            return { value: pc };
          }
        );
      } else {
        colors = self.colors.map((c) => {
          return { value: c.name };
        });
      }
      if (queryString == null) {
        cb(colors);
      } else {
        cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectColor(index) {
      this.formObj.items[index].color = Util.jyTrim(
        this.formObj.items[index].color
      );
      this.checkExist(index);
    },
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      let sizes = [];
      if (this.formObj.items[self.currentIndex]._productNoSizes.length !== 0) {
        sizes = this.formObj.items[self.currentIndex]._productNoSizes.map(
          (pc) => {
            return { value: pc };
          }
        );
      } else {
        sizes = self.sizes.map((c) => {
          return { value: c.name };
        });
      }
      if (queryString == null) {
        cb(sizes);
      } else {
        cb(sizes.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectSize(index) {
      this.formObj.items[index].color = Util.jyTrim(
        this.formObj.items[index].color
      );
      this.checkExist(index);
    },

    addMore() {
      this.formObj.items.push(bulid());
    },
    remove(index) {
      this.formObj.items.splice(index, 1);
    },
    saveSubmit() {
      const self = this;

      self.$refs.formObjForm.validate((valid) => {
        if (valid) {
          const items = JSON.parse(JSON.stringify(self.formObj.items)).filter(
            (item) =>
              item.productNo != null &&
              item.productNo !== "" &&
              item.quantity != null &&
              item.quantity != ""
          );
          if (items.length === 0) {
            this.$message({
              message: self.$t("prompt.atLeastOneDataFill"),
              type: "warning",
            });
            return;
          }
          const data = [];
          for (const item of items) {
            if (item._localRepeatFg === true) {
              self.$message({
                message: self.$t("prompt.errorMessage"),
                type: "warning",
              });
              return;
            }

            if (!Util.regexQuantity(item.quantity)) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("inventory.quantity"),
                ]),
                type: "warning",
              });
              return;
            }
            if (
              item.warnQuantity != null &&
              item.warnQuantity != "" &&
              !Util.regexQuantity(item.warnQuantity)
            ) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("inventory.warnQuantity"),
                ]),
                type: "warning",
              });
              return;
            }
            item.shopId = self.shopId;
            item.color = Util.jyTrim(item.color);
            item.size = Util.jyTrim(item.size);
          }
          self.saveDoing = true;
          Inventory.batchCheck(items).then(function (res) {
            if (res.status === 200) {
              self.saveDoing = false;
              self.$message({
                message: self.$t("prompt.checkSuccess"),
                type: "success",
              });
              self.$router.push({ name: "wmsInventories" });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>